import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import SpringwoodIcon from './SpringwoodIcon';
import DDIcon from "./DDIcon";
import SophkosIcon from './SophkosIcon';
import Link from "@mui/material/Link";

const logos = [
    {
        logo: <SpringwoodIcon/>,
        link: 'https://springwood-capital.com/',
    },
    {
        logo: <DDIcon/>,
        link: 'https://www.digidoe.com/',
    },
    {
        logo: <SophkosIcon/>,
        link: 'https://sophkos.com/',
    },
];


export default function LogoCollection() {

  return (
    <Box id="logoCollection" sx={{ py: 4 }}>
      <Typography
        component="h2"
        variant="h3"
        align="center"
        sx={{ color: 'hsl(201,100%,36%)' }}
      >
        Partners and clients
      </Typography>
    <br/>
      <Grid container sx={{ justifyContent: 'center', mt: 0.5 }}>
        {logos.map((logo, index) => (
          <Grid item key={index}>
              <Link href={logo.link} target={"_blank"} underline={"none"}>{logo.logo}</Link>
          </Grid>
        ))}
      </Grid>
      
    </Box>
  );
}
